<template>
  <Head title="Admin - Manage Users" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <manage-users 
            :user="auth.user" 
            :clients="agencyClients"  
            :users="users" 
            :agencies="agencies"
          ></manage-users>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  auth: Object,
  agencyClients: Array,
  users: Array,
  agencies: Array
});
</script>

